import { render, staticRenderFns } from "./VehicleChangeFrequencyStepComponent.vue?vue&type=template&id=8746206c"
import script from "./VehicleChangeFrequencyStepComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleChangeFrequencyStepComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports